import Header from './Header'
import About from './About';
import Project from './Project';
import Contact from './Contact';
import Footer from './Footer';
import Signup from './Signup';
import Information from './Information';
import Water from './Water';




function App() {
  return (
    <>
      <Header />
      <About />
      <Information/>
      <Project />
      <Water/>
      <Signup/>
      <Contact/>
      <Footer />
    </>
  );
}

export default App;
